// @ts-strict-ignore

import { clinicRoutes } from "@clinic/shared/data/clinicRoutes";

const practitionerRoutes = {
  ...clinicRoutes,
  account: "/p/stores/account",
  peerReferrals: "/o/peer_referrals",
  referral: "/p/stores/referral",
  store_welcome: "/p/welcome",
  wrong_account_type: "/p/wrong-account-type",
  stock_locations: "/w/stock_locations",
  npSync: "/w/np-sync",
  taxEdit: clinicRoutes.storeSettings.paymentsTaxEdit,

  landingPagePreview: urlSlug => `/welcome/${urlSlug}?preview=true`,
  switch_accounts: "/accounts",
} as const;

export { practitionerRoutes };
